import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HotelService } from './hotel.service';
import { ApiResponse } from '../interfaces/api-response';

@Injectable({ providedIn: 'root' })
export class BookingNotificationService {
  private pendingCountSubject = new BehaviorSubject<number>(0);
  pendingCount$ = this.pendingCountSubject.asObservable();

  constructor(private hotelService: HotelService) {}

  setPendingCount(count: number): void {
    this.pendingCountSubject.next(count);
  }

  decrementPendingCount(): void {
    const currentCount = this.pendingCountSubject.value;
    if (currentCount > 0) {
      this.pendingCountSubject.next(currentCount - 1);
    }
  }

  incrementPendingCount(): void {
    const currentCount = this.pendingCountSubject.value;
    this.pendingCountSubject.next(currentCount + 1);
  }

  fetchPendingCountFromAllPages(): void {
    this.hotelService.getSelectedHotelPendingCount().subscribe({
      next: (response: ApiResponse<{ count: number }> | null) => {
        if (response?.data) {
          this.setPendingCount(response.data.count);
        } else {
          this.setPendingCount(0);
        }
      },
      error: () => {
        this.setPendingCount(0);
      }
    });
  }
}
